import ReactDOM from 'react-dom/client';
import 'moment-timezone';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';
import Events from './admin/Events';
import Event from './user/Event';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EventReport from './user/EventReport';
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { MsalProvider } from "@azure/msal-react";
import Permission from './Permision';
import MyEvent from './user/MyEvent';
import HomeEvent from './user/HomeEvent';
import LanguageLabels from './admin/LanguageLabels';
import EmailConfig from './admin/EmailConfig';
import BrowseEvents from './user/BrowseEvents';
import UpdateCardNo from './admin/UpdateCardNo';
import Forms from './admin/Forms';
import FormBuilder from './admin/FormBuilder';
import FormFill from './user/FormFill';
import FormReport from './admin/FormReport';
import MyForms from './user/MyForms';
import WebhookLogs from './admin/WebhookLogs';
import "./newrelic";
import axios from 'axios';

export const msalInstance = new PublicClientApplication(msalConfig);

//get initialize msalInstance
msalInstance.initialize();

const activeAccount = msalInstance.getActiveAccount();

if (!activeAccount) {
  // Account selection
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
}

//set the account
msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const authenticationResult = event.payload as AuthenticationResult;
    const account = authenticationResult.account;
    msalInstance.setActiveAccount(account);
  }
});

//enable account storage event
msalInstance.enableAccountStorageEvents();

// Global axios interceptor — silent token refresh on 401/403, logout only if refresh fails
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    if ((status === 401 || status === 403) && !error.config?._retry) {
      error.config._retry = true;
      try {
        const activeAccount = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
        if (activeAccount) {
          const result = await msalInstance.acquireTokenSilent({
            scopes: [`${process.env.REACT_APP_API_SCOPE1}`],
            account: activeAccount,
          });
          sessionStorage.setItem("accessToken", result.accessToken);
          localStorage.setItem("accessToken", result.accessToken);
          error.config.headers['Authorization'] = `Bearer ${result.accessToken}`;
          return axios(error.config);
        }
      } catch (_) {
        // silent refresh failed — fall through to logout
      }
      sessionStorage.clear();
      msalInstance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <MsalProvider instance={msalInstance}>
    <BrowserRouter basename={process.env.REACT_APP_PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<HomeEvent />} />
        <Route path="/home" element={<HomeEvent />} />
        <Route path="/admin" element={<App />} />
        <Route path="/events" element={<Events />} />
        <Route path="/event/:eventnumber" element={<Event />} />
        <Route path="/event/:eventnumber/report" element={<EventReport />} />
        <Route path="/accessdenied" element={<Permission />} />
        <Route path="/myevents" element={<MyEvent />} />
        <Route path="/language-labels" element={<LanguageLabels />} />
        <Route path="/email-config" element={<EmailConfig />} />
        <Route path="/browse/:section" element={<BrowseEvents />} />
        <Route path="/update-card-no" element={<UpdateCardNo />} />
        <Route path="/forms" element={<Forms />} />
        <Route path="/form-builder" element={<FormBuilder />} />
        <Route path="/form/:code" element={<FormFill />} />
        <Route path="/myforms" element={<MyForms />} />
        <Route path="/form-report" element={<FormReport />} />
        <Route path="/webhook-logs" element={<WebhookLogs />} />
      </Routes>
    </BrowserRouter>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
